import { environment } from './../../../../environments/environment';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from 'gung-standard';
import { filter, first, map, tap } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'ref-ref-welcome',
    templateUrl: './ref-welcome.component.html',
    styleUrls: ['./ref-welcome.component.scss'],
    standalone: false
})
export class RefWelcomeComponent implements OnInit, OnDestroy {
  roleSubscription: Subscription;

  constructor(protected authSevice: AuthService, protected router: Router) {}

  ngOnInit() {
    this.subscribeToRoles();
  }

  ngOnDestroy() {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
    }
  }

  subscribeToRoles() {
    if (environment.projectName === 'ref') {
      return;
    }
    this.authSevice
      .getRoles()
      .pipe(
        filter(roles => !!roles),
        first()
      )
      .subscribe(roles => {
        if (roles.indexOf('SALES') > -1 || roles.indexOf('ADMIN') > -1) {
          this.router.navigate(['/statistics']);
        } else {
          this.router.navigate(['/products']);
        }
      });
  }
}
